<template>
  <div v-if="!!cargaEfetivaTributaria" class="calculo-cet-container">
    <Registro paddingSemCheckBox>
      <label>Carga Efetiva Tributária</label>
      <span>{{formatPercent(cargaEfetivaTributaria.toString())}}</span>
    </Registro>
  </div>
</template>

<script>
import Registro from '@/components/Registro/Registro.vue'

import stringFormatMixin from '@/mixins/stringFormatMixin'
export default {
  name: 'CalculoComplemento',

  mixins: [stringFormatMixin],

  props: {
    cargaEfetivaTributaria: Number
  },

  components: {
    Registro
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.calculo-cet-container {
  margin-top: 1rem;

  .registro-content {
    display: flex;
    justify-content:space-between;

    label, span {
      margin-bottom: 0;
      font-weight: 600;
    }
  }
}

</style>